
export type VoteOnPollBody = {
  /** 투표할 옵션 ID */
  optionId: string;
};
